<template>
  <el-card class="mtop">
    <div ref="chartContainer" style="width: 100%; height: 600px;" />
  </el-card>
</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'EchartLevel',
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '等级流失'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '20%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
          // dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            // restore: {},
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            var tooltipContent = ''
            params.forEach(function(item) {
              if (item.value > 0) {
                tooltipContent += item.seriesName + ' : ' + item.value + '<br/>'
              }
            })
            return tooltipContent
          }
        },
        series: []
      }
      this.chart.setOption(this.option)
    },
    refresh(res) {
      this.initChart()
      const tableData = res.data.data
      const date = []
      const data = {}
      for (const i in tableData) {
        date.push(dateStrTodate(tableData[i].date))
        for (const k in tableData[i].level_data) {
          const val = tableData[i].level_data[k]
          if (data[k] === undefined) {
            data[k] = []
          }
          data[k].push(val)
        }
      }

      for (const i in data) {
        const d = data[i]
        this.option.legend.data.push('等级' + i)
        const temp = {
          name: '等级' + i,
          data: d,
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}%' // 显示数值
          }
        }
        this.option.series.push(temp)
      }

      this.option.xAxis.data = date
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 10px;
}
</style>
